import React, {useState} from 'react'
import { News, SearchMovies, SearchActors } from '../components'
import {BiSolidLeftArrow, BiSolidRightArrow} from 'react-icons/bi'


const Homepage = () => {

  const [search, setSearch] = useState("MOVIE")

  return (
    <div style={{minHeight: "600px", display: "flex", flexDirection: "column", alignItems: "center", width: "full"}}>

    <div className='arrow-container'>
      <div className={`${search === "MOVIE" ? "active" : ""}`}>
        {/* <BiSolidLeftArrow onClick={() => setSearch("MOVIE")}/> */}
        <h2 onClick={() => setSearch("MOVIE")}>Movies</h2>
      </div>
      <div className={`${search === "ACTOR" ? "active" : ""}`}>
        {/* <BiSolidRightArrow onClick={() => setSearch("ACTOR")}/> */}
        <h2 onClick={() => setSearch("ACTOR")}>Actors</h2>
      </div>
    </div>

    {search === "MOVIE" && (
          <SearchMovies/>
    )}
    
    {search === "ACTOR" && (
          <SearchActors/>
    )}

   
    </div>
  )
}

export default Homepage